<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <b-button variant="success mr-1" @click="save">Save</b-button>
          <b-button variant="warning" @click="close">Close</b-button>
        </div>
      </div>
      <simpleFormVue :itemSimpleForm="itemSimpleForm" :$v="$v" :model="model"/>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import myNumber from "../../components/my-number.vue";
toastr.init();

import simpleFormVue from "../../components/simpleForm.vue";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  components: { Loading, myNumber,simpleFormVue },
  mixins: [validationMixin],
  validations: {
    model: {
      kode: { required },
      nama: { required },
    },
  },
  data() {
    return {
      showFilter: true,
      isBusy: false,
      isLoading:false,
      isInsert: true,
      model: {
        kode: "",
        nama: "",
      },
      itemSimpleForm: {
        kode: { type: "text" ,col:6},
        nama: { type: "text",col:6 },
      },
      // [] = array
      // {} = obj
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  async created() {
    if (this.$route.params.kode){
      toastr.info("Loading Region Form Form, Please Wait...");
      try {
        this.isInsert=false;
        const data = await crud.detail({
          tablename: "wilayah",
          key: this.$route.params.kode,
        });
        const row = data;
        for (var key in row) {
          this.model[key] = row[key];
        }
        this.$forceUpdate();
        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
      }
    }
  },
  methods: {
    save: async function () {
      try {
        if (this.invalidModel) {
          toastr.error("Please fill the form correctly.", "Error Info");
        } else {
          this.isLoading=true;
          let tablename = "wilayah";
          let data = {
                kode: this.model.kode,
                nama: this.model.nama,
          }

          if(!this.isInsert){
            await crud.update({
              tablename,
              key: this.model.kode,
              data
            });
          } else {
            await crud.insert({
              tablename,
              data
            });
          }
        this.isLoading=false; 
        toastr.success(`Success save region.`, "Save Region",10000);
        this.close();
        }
      } catch (error) {
        this.isLoading=false; 
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    close() {
      router.push({ name: "master.region" });
    },
  },
};
</script>